import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export class EluxValidators {
  static email(): ValidatorFn {
    const pattern = /^[\w.%+-]+@electrolux\.com$/i

    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value
      if (!value) return null

      return pattern.test(value) ? null : { eluxEmail: true }
    }
  }

  static minLength(length: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value
      if (!value) return null
      return value.length >= length ? null : { eluxMinLength: length }
    }
  }

  static confirmPasswordValidator(passwordField: string, confirmField: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const password = formGroup.get(passwordField)?.value
      const confirmControl = formGroup.get(confirmField)
      const confirm = confirmControl?.value
      const errors = confirmControl?.errors || null
      const hasPasswordMismatch = !!errors?.['eluxPasswordMismatch']

      if (password !== confirm) {
        if (!hasPasswordMismatch) {
          confirmControl?.setErrors({ ...(errors || {}), eluxPasswordMismatch: true })
        }
        return { eluxPasswordMismatch: true }
      }

      if (hasPasswordMismatch) {
        const { eluxPasswordMismatch, ...remainingErrors } = errors as ValidationErrors
        confirmControl?.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null)
      }

      return null
    }
  }

  static url(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value

      if (!value) {
        return null
      }

      try {
        const url = new URL(value)
        const isValidProtocol = url.protocol === 'http:' || url.protocol === 'https:'
        const hasDotInHostname = url.hostname.includes('.') && url.hostname.split('.').pop() !== ''

        return isValidProtocol && hasDotInHostname ? null : { eluxUrlIsInvalid: true }
      } catch {
        return { eluxUrlIsInvalid: true }
      }
    }
  }
}
